module.exports = __webpack_public_path__ + "img/site_bwin437_ver2.03c2fdc1.png";